import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { Images } from "../Common/Images.jsx";
import { ResetPassword_api, ValidateResetPasswordToken_api } from "./LoginAPI.js";
import LanguageDropdown from "../Common/LanguageDropdown.jsx";
import { AppConstant } from "../../config/AppConstants.js";
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import NotificationMessage from "../Common/NotificationMessage.jsx";
import { delay, isPasswordLongEnough, PASSWORD_MIN_LENGTH } from "../../utils/CommonUtils.js";
import { useEffect } from "react";

// Same complexity rule as Login registration (LoginEvent.jsx): at least one digit,
// one lowercase letter, one uppercase letter and one special character.
const passwordletters = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/;

function ResetPassword() {
    const [ClientId, setClientId] = useState(AppConstant.DEFAULT_CLIENT_ID);
    const { t } = useTranslation("common");
    const history = useHistory();
    const { uniqueId = "" } = useParams();
    //const [uniqueId, setUniqueId] = useState("");
    const [hasValidUniqueId, setHasValidUniqueId] = useState(null);
    console.log("uniqueId from url-", uniqueId, "hasValidUniqueId-", hasValidUniqueId);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [notification, setNotification] = useState(null);
    const [successMsg, setSuccessMsg] = useState("");
    const [isLoading, setIsLoading] = useState(true);
console.log("isLoading 1-", isLoading);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setNewPasswordError("");
        setConfirmPasswordError("");

        if (!newPassword || newPassword.trim() === "") {
            setNewPasswordError(t("please_enter_password"));
            return;
        }

        // Minimum length is shared with Settings → Change Password (CommonUtils).
        if (!isPasswordLongEnough(newPassword)) {
            setNewPasswordError(t("Mini_length_s_password").replace("%s", PASSWORD_MIN_LENGTH));
            return;
        }

        if (!passwordletters.test(newPassword)) {
            setNewPasswordError(t("react_password_requirements"));
            return;
        }

        if (!confirmPassword || confirmPassword.trim() === "") {
            setConfirmPasswordError(t("please_enter_password"));
            return;
        }

        if (newPassword !== confirmPassword) {
            setConfirmPasswordError(t("password_and_confirm_password_should_be_same"));
            return;
        }

        const requestParams = {
            ClientId,
            Code: uniqueId,
            Password: newPassword,
            //ConfirmPassword: confirmPassword
        };

        const response = await ResetPassword_api(requestParams);
        /* handleApiResponse(response, setNotification, t, {
            successMsg: 1,
            errorMsg: 1
        }); */
        if (response?.Data?.ResponseCode === 200) {
            setSuccessMsg(response?.Data?.Message);
            await delay(2000);
            history.push("/login");
        }
        else { setConfirmPasswordError(response?.Data?.ErrorMessage); }
    };

   useEffect(() => {
    const validateToken = async () => {
        setIsLoading(true);

        const reqParams = {
            ClientId,
            Code: uniqueId
        };

        try {
            const response = await ValidateResetPasswordToken_api(reqParams);

            if (response?.Data?.ResponseCode === 200) {
                setHasValidUniqueId(true);
            } else {
                setHasValidUniqueId(false);
            }

            console.log("API response:", response);
        } catch (error) {
            console.error("Error validating token:", error);
            setHasValidUniqueId(false);
        } finally {
            setIsLoading(false); // ✅ ONLY after API finishes
        }
    };

    validateToken();
}, []);


    return (
        <div className={`main-area ${!hasValidUniqueId ? "main-bg-remove" : ""}`}>
            {isLoading && (
                <div id='preloader'>
                    <img src={Images.LoaderFull} alt="" />
                </div>
            )}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-4 col-xl-5 col-12 p-0 w-38">
                        <div className="green-opacity left-panel">
                            <div className="welcome-intro">
                                <h1>{t("welcome_the_ronspot_booking_app")}</h1>
                                <p>{t("enter_your_professional_email_address_manage_bookings")}</p>
                                <ul className="checklist pb-3 d-none d-lg-block">
                                    <li>{t("view_real_time_availability_your_office")}</li>
                                    <li>{t("react_book_your_favourite_space_in_advance")}</li>
                                    <li>{t("not_coming_cancel_your_booking_anytime")}</li>
                                    <li>{t("also_available_android_ios_teams")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-6 col-xl-7 col-12 d-flex align-items-center justify-content-center p-0 vh-full">
                        {hasValidUniqueId ? (
                            <div className="content-wrapper">
                                <div className="white-opacity blur-area login-box">
                                    <div className="logo-form-wrapper">
                                        <div className="logo-with-subline text-center fade-in-animation">
                                            <div className="vertical-logo text-center">
                                                <img src={Images.RonspotSquareLogo} alt="logo" className="img-fluid" />
                                            </div>
                                        </div>

                                        <div className="form-layout me-2 login-form-stage">
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-elements">
                                                    <label htmlFor="reset-new-password" className="form-label">
                                                        {t("new_password")}
                                                    </label>
                                                    <div className="position-relative">
                                                        <input
                                                            id="reset-new-password"
                                                            type={showNewPassword ? "text" : "password"}
                                                            className="form-control"
                                                            value={newPassword}
                                                            onChange={(e) => {
                                                                setNewPassword(e.target.value);
                                                                if (newPasswordError) {
                                                                    setNewPasswordError("");
                                                                }
                                                            }}
                                                        />
                                                        <i
                                                            className={`toggle-password fas ${showNewPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                            onClick={() => setShowNewPassword((prev) => !prev)}
                                                        ></i>
                                                    </div>
                                                    {newPasswordError && (
                                                        <p className="error-msg">{newPasswordError}</p>
                                                    )}
                                                </div>

                                                <div className="form-elements">
                                                    <label htmlFor="reset-confirm-password" className="form-label">
                                                        {t("confirm_new_password")}
                                                    </label>
                                                    <div className="position-relative">
                                                        <input
                                                            id="reset-confirm-password"
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            className="form-control"
                                                            value={confirmPassword}
                                                            onChange={(e) => {
                                                                setConfirmPassword(e.target.value);
                                                                if (confirmPasswordError) {
                                                                    setConfirmPasswordError("");
                                                                }
                                                            }}
                                                        />
                                                        <i
                                                            className={`toggle-password fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                                        ></i>
                                                    </div>
                                                    {confirmPasswordError && (
                                                        <p className="error-msg">{confirmPasswordError}</p>
                                                    )}
                                                </div>
                                                {successMsg && (
                                                    <p className="success-msg">{successMsg}</p>
                                                )}
                                                <div className="submit-btn">
                                                    <button type="submit">{t("update")}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (

                            <div id="page-content">
                                <div className="block inactive_message">
                                    <div>
                                        <h3 className="text-center text-green">
                                            <p>{t("reset_password_link_sentense1")}</p>
                                            <p>{t("reset_password_link_sentense2")}</p>
                                            <p>{t("reset_password_link_sentense3")}</p>
                                        </h3>
                                    </div>
                                </div>
                            </div>

                        )}
                    </div>
                </div>
            </div>

            <LanguageDropdown />

            {notification && (
                <NotificationMessage
                    type={notification.type}
                    title={notification.title}
                    message={notification.message}
                    onClose={() => setNotification(null)}
                />
            )}
        </div>
    );
}

export default ResetPassword;
